import { c as _c } from "react/compiler-runtime";
import { LightCard } from '../../../../../../../data-display/Card';
import { H3 } from '../../../../../../../typography/Heading';
type ContentCardProps = {
  title: string;
  children: React.ReactNode;
};
export function ContentCard(t0) {
  const $ = _c(7);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <H3>{title}</H3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="space-y-1 font-normal text-base text-contentInverseSecondary leading-6">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <LightCard className="w-full space-y-4 bg-backgroundTertiary">{t1}{t2}</LightCard>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}